import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  firstText: {
    background: theme.palette.subscription.primary.light,
    padding: theme.spacing(2),
    border: `2px solid ${(theme.palette.common.black, 0.5)}`,
    borderRadius: 7,
  },
  containerBox: {
    margin: theme.spacing(0, 3),
    display: 'flex',
    flexDirection: 'column',
  },
  link: {
    cursor: 'pointer',
    color: theme.palette.primary.hover,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  inputFile: {
    display: 'none',
  },

  box: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '30%',
    border: '2px dotted black',
  },
}))
